export default __webpack_public_path__ + "static/media/1957.40a94141.png";